import { arrayMove } from '@dnd-kit/sortable';
import { LIST_DROPPABLE_PREFIX } from './constants';
export const reorderItems = ({ items, itemsWithIds, activeId, overId, onReorder }) => {
    const oldIndex = itemsWithIds.findIndex((item) => item.id === activeId);
    const newIndex = itemsWithIds.findIndex((item) => item.id === overId);
    if (oldIndex !== -1 && newIndex !== -1) {
        const reorderedItems = arrayMove(items, oldIndex, newIndex);
        onReorder?.(reorderedItems);
    }
};
export const getListDroppableId = (listId) => `${LIST_DROPPABLE_PREFIX}${listId}`;
export const isListDroppableId = (id) => id.startsWith(LIST_DROPPABLE_PREFIX);
export const getListIdFromDroppableId = (droppableId) => droppableId.replace(LIST_DROPPABLE_PREFIX, '');
const isObject = (value) => typeof value === 'object' && value !== null;
export const getOrCreateObjectItemId = (item, idMap, counterRef, prefix) => {
    const existingId = idMap.get(item);
    if (existingId) {
        return existingId;
    }
    const newId = `${prefix}-${counterRef.current++}`;
    idMap.set(item, newId);
    return newId;
};
export const getOrCreateItemId = (item, idMaps, counterRef, prefix) => {
    if (isObject(item)) {
        const existingId = idMaps.objectMap.get(item);
        if (existingId) {
            return existingId;
        }
        const newId = `${prefix}-${counterRef.current++}`;
        idMaps.objectMap.set(item, newId);
        return newId;
    }
    const existingId = idMaps.primitiveMap.get(item);
    if (existingId) {
        return existingId;
    }
    const newId = `${prefix}-${counterRef.current++}`;
    idMaps.primitiveMap.set(item, newId);
    return newId;
};
export const createItemIdMaps = () => ({
    objectMap: new WeakMap(),
    primitiveMap: new Map()
});
export const findItemIndex = (list, itemId, getItemId) => list.items.findIndex((item) => getItemId(item) === itemId);
export const findItem = (list, itemId, getItemId) => list.items.find((item) => getItemId(item) === itemId);
